import axios from 'axios';
import { stringify } from "qs";
import { initializeRatesGrid } from "../establishments/components/init-rates-grid";
import { initializePopovers } from "../general/initialize-popover.js";
import { clearAllBodyScrollLocks, disableBodyScroll } from "body-scroll-lock";
import { checkSelectedInputs } from '../reviews/review-filter-sort-utilities.js';
import { resetValidationInputCheck } from '../general/form-validation.js';


const { page_name, site, is_mobile_device } = window.tg;
let url = new URL(document.URL);

export default () => {
    return {
        open: false,
        trayHeightUpdated: false,
        trayHeight: 0,
        dragPosition: undefined,
        tray: null,
        trayContents: null,
        draggableArea: null,
        data: {},
        subHeader: '',
        customFooter: '',
        loading: false,
        pageLoadTrays: ['followers', 'following', 'reward-points-history', 'social-post-tray', 'invite-friends', 'invite-accepted'],
        init() {
            this.tray = this.$refs.bottomTray
            this.trayContents = this.tray.querySelector(".contents")
            this.draggableArea = this.tray.querySelector(".draggable-area")

            // Watch for changes in openTray value which will be changed when a tray is opened
            this.$watch('$store.general.tray.openTray', (newValue, oldValue) => {
                this.setIsTrayShown(newValue !== 'NONE')
            })

            // Open tray on page load if there is a query parameter for it
            if (url.searchParams.has("tray") && this.pageLoadTrays.includes(url.searchParams.get("tray"))) {
                const trayToOpen = url.searchParams.get("tray")
                let trayTitle = ''
                let additionalData = {};
                if (trayToOpen == 'invite-friends') {
                    let source = 'signup';
                    if (url.searchParams.has("source")) {
                        source = url.searchParams.get("source");
                    }
                    additionalData = { 'source': source }
                    trayTitle = source == 'follow' ? 'Invite your friends to follow you' : 'Invite your friends to Viya!'
                }

                if (trayToOpen == 'invite-accepted') {
                    let handle = url.pathname.split("/social/profile/")[1]
                    additionalData = { 'handle': handle }
                }
                this.$store.general.updateOpenTray(trayToOpen, trayTitle, 0, true, 80, false, false, additionalData)

            }

            // Close tray on browser back (try popstate with debounce)
            // window.addEventListener('popstate', function(event) {
            //     if (vm.$store.general.openSection == 'TRAY') {
            //         vm.$store.general.updateOpenTray('NONE')
            //     }
            // });
        },
        setTrayContent(closing = false) {
            const vm = this
            const target = this.$store.general.tray.openTray
            const trayContentWrapper = this.tray.querySelector('.tray-body .tray-content-wrapper')
            const trayBody = document.querySelector(".tray-body")


            // Closing tray
            if (closing) {
                this.open = false

                if (trayContentWrapper.querySelector('#form-sidebar-filters')) {
                    trayContentWrapper.querySelectorAll('.results-tray').forEach((el) => {
                        el.classList.add('d-none')
                    })
                    this.relocateElementBySelector('#form-sidebar-filters', '#slideout-options')

                }

                trayContentWrapper.innerHTML = ''
                vm.subHeader = ''
                vm.customFooter = ''

                if (url.searchParams.has("tray")) {

                    if (url.searchParams.get("tray") == 'social-post-tray') {
                        let media = this.$store.general.media
                        let panel = this.$store.general.panel

                        if (this.$store.general.editor) {
                            this.$store.general.editor.destroy()
                        }

                        media.forEach((media) => {
                            if (media.edited_file_url == media.original_file_url) {
                                URL.revokeObjectURL(media.original_file_url);
                                URL.revokeObjectURL(media.watermark_image);
                            } else {
                                URL.revokeObjectURL(media.original_file_url);
                                URL.revokeObjectURL(media.edited_file_url);
                                URL.revokeObjectURL(media.watermark_image);
                            }
                        });

                        if (panel == 'POSTED') {
                            // TODO: make new content load after posted
                            url.searchParams.delete('tray')

                            // For posting prompt email links
                            url.searchParams.delete('post');
                            url.searchParams.delete('funnel');
                            url.searchParams.delete('thread_id');
                            url.searchParams.delete("points_earned")

                            history.pushState({}, "", url)
                            window.location.reload();
                        }

                    }

                    if (url.searchParams.has("source")) {
                        url.searchParams.delete('source')
                    }
                    url.searchParams.delete('tray')
                    history.pushState({}, "", url)
                }

                return
            }

            // Show loader
            if (target != 'share') {
                trayContentWrapper.innerHTML = loadingTrayHtml
                this.loading = true
            }

            // Opening tray
            this.open = true
            // Only add to URL if we need it on page load
            if (this.pageLoadTrays.includes(target)) {
                url.searchParams.set('tray', target)
                history.pushState({}, "", url)
            }

            if (this.$store.general.tray.ajaxLoaded) {
                this.data.itemId = this.$store.general.tray.itemId

                switch (target) {
                    case 'social-post-tray':
                        let urlParams = new URLSearchParams(window.location.search);
                        this.data = {
                            'capture_image': urlParams.get('capture_image') || "",
                            'image_id': urlParams.get('image_id') || "",
                            'video_id': urlParams.get('video_id') || "",
                            'thread_id': urlParams.get('thread_id') || 0,
                            'property_id': urlParams.get('property_id') || 0,
                            'property_name': urlParams.get('property_name') || "",
                            'region_id': urlParams.get('region_id') || 0,
                            'funnel': urlParams.get('funnel') || "",
                        }

                        if (this.$store.general.tray.additionalData.propertyId != undefined) {
                            this.data.property_id = this.$store.general.tray.additionalData.propertyId
                        }

                        if (this.$store.general.tray.additionalData.propertyName != undefined) {
                            this.data.property_name = this.$store.general.tray.additionalData.propertyName
                        }

                        if (this.$store.general.tray.additionalData.regionId != undefined) {
                            this.data.region_id = this.$store.general.tray.additionalData.regionId
                        }

                        if (this.$store.general.tray.additionalData.bookingThreadId != undefined) {
                            this.data.thread_id = this.$store.general.tray.additionalData.bookingThreadId
                        }

                        if (this.$store.general.tray.additionalData.funnel != undefined) {
                            this.data.funnel = this.$store.general.tray.additionalData.funnel
                        }

                        if (this.$store.general.tray.additionalData.captureImage != undefined) {
                            this.data.capture_image = this.$store.general.tray.additionalData.captureImage
                        }
                        break;
                    case 'comments':
                        this.data.content_id = this.$store.general.tray.itemId
                        this.data.content_type = this.$store.general.tray.contentType
                        break;
                    case 'followers':
                    case 'following':
                        this.data.user_id = document.querySelector(`.js-${target}[data-user-id]`).dataset.userId
                        break;
                    case 'login':
                        const partner_membership = JSON.parse(window.tg.partner_membership)
                        if (partner_membership && partner_membership.partner === 'sl') {
                            this.$store.general.tray.additionalData.email = partner_membership.membership.current_member.EmailAddress
                        }
                        break;
                    case 'filter':
                        let property_id = document.querySelector("#reviews_filter_sort_div")?.getAttribute("data-eid") ?? null;
                        this.data.property_id = property_id;
                        break;
                }

                axios({
                    url: '/backend/cms/tray',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    data: stringify({
                        target: target,
                        subHeader: this.$store.general.tray.subHeader,
                        customFooter: this.$store.general.tray.customFooter,
                        data: this.data,
                        additionalData: this.$store.general.tray.additionalData,
                    }),
                }).then((response) => {
                    const output = response.data;
                    if (output.success) {
                        if (target == 'social-post-tray') {
                            let dom = new DOMParser().parseFromString(output.data.tray_body, 'text/html')
                            dom.querySelectorAll('script').forEach((scriptEl) => {
                                const newScriptEl = document.createElement('script')
                                Array.from(scriptEl.attributes).forEach(attribute => {
                                    newScriptEl.setAttribute(attribute.name, attribute.value)
                                })
                                newScriptEl.innerHTML = scriptEl.innerHTML
                                document.head.appendChild(newScriptEl)
                            })
                            Alpine.store('general').tray.openTray = 'social-post-tray'
                        }

                        trayContentWrapper.innerHTML = output.data.tray_body
                        this.loading = false

                        if (target == 'single-review') {
                            this.reviewTranslation();
                            this.responseTranslation();
                            window.bind_swiper(".js-swiper-peek", "single-review")
                        }

                        if (output.data.sub_header) {
                            vm.subHeader = output.data.sub_header
                        }

                        if (output.data.custom_footer) {
                            vm.customFooter = output.data.custom_footer
                        }

                        if (target == 'collection') {
                            initializePopovers();
                        }

                        if (target == 'filter') {

                            // Ensure that we check all the filters that were active on the tray
                            const div = output.data.tray_body;
                            const inputs = document.querySelectorAll('#js-model-filter-reviews input[type="checkbox"]');
                            checkSelectedInputs(inputs);
                        }

                        if (target == 'user-verification') {
                            const input = document.querySelector('input[autocomplete="one-time-code"]');
                            if (input) {
                                document.dispatchEvent(new Event('verificationModalShown'));
                            } else {
                                const observer = new MutationObserver(() => {
                                    const input = document.querySelector('input[autocomplete="one-time-code"]');
                                    if (input) {
                                        document.dispatchEvent(new Event('verificationModalShown'));
                                        observer.disconnect();
                                    }
                                });
                                observer.observe(trayContentWrapper, { childList: true, subtree: true });
                            }
                        }

                        if (site == 'ls' && target == 'sort') {
                            const sort_options = document.querySelectorAll('input[name="sort_option"]');
                            const currentSortType = Alpine.store('review').sort_type;

                            // If currentSortType is not set, default to Recommended, Otherwise set the current sort type
                            sort_options.forEach(sort_option => {
                                if (sort_option.getAttribute('value') === currentSortType ||!currentSortType && sort_option.id === "Recommended") {
                                    sort_option.checked = true;
                                }
                            });
                        }

                        const disableScrollLocksOnClick = (el) => {
                            el.addEventListener('click', function() {
                                clearAllBodyScrollLocks()
                            })
                        }

                        // disable body scroll when tray is open
                        if (['signup-form-tray', 'filter', 'sort', 'login'].includes(target) && site === 'ls') {
                            disableBodyScroll(trayBody);
                        }

                        // Enable body scroll when tray is closed
                        const trayCloseX = document.getElementById('close-tray-x')
                        const trayOverlay = document.querySelector('.js-tray-overlay')
                        if (trayCloseX || trayOverlay) {
                           disableScrollLocksOnClick(trayCloseX);
                           disableScrollLocksOnClick(trayOverlay);
                        }

                        if (this.$store.general.tray.additionalData.scrollToSection) {
                            const className = this.$store.general.tray.additionalData.sectionName;
                            const targetSection = this.tray.querySelector('.' + className);

                            if (targetSection) {
                                const targetOffset = targetSection.offsetTop - trayBody.offsetTop;
                                trayBody.scrollTop = targetOffset; // Scroll to the target section
                            }
                        }

                        if (['signup-form-tray', 'login'].includes(target)) {
                            resetValidationInputCheck();
                        }
                    }
                });
            } else {
                if (!['share', 'room-details'].includes(target)) {
                    let targetTrayContent = document.getElementById(`${target}-tray`)

                    if (this.$store.general.tray.customFooter) {
                        axios({
                            url: '/backend/cms/get_custom_tray_footer',
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            data: stringify({
                                target: target,
                                additionalData: this.$store.general.tray.additionalData,
                                scrollToSection: this.$store.general.tray.scrollToSection,
                            }),
                        }).then((response) => {
                            const output = response.data;

                            if (output.success) {
                                if (output.data.custom_footer) {
                                    vm.customFooter = output.data.custom_footer
                                }
                            }
                        });
                    }

                    if (['results-filters', 'results-price', 'results-sort'].includes(target)) {
                        trayContentWrapper.innerHTML = ""
                        this.relocateElementBySelector('#form-sidebar-filters', '.tray-body .tray-content-wrapper')
                        trayContentWrapper.querySelectorAll('.results-tray').forEach((el) => {
                            el.id == `${target}-tray` ? el.classList.remove('d-none') : el.classList.add('d-none')
                        })
                    } else {
                        trayContentWrapper.innerHTML = targetTrayContent.innerHTML
                    }

                    if (target == 'establishment-rates') {
                        initializeRatesGrid('#js-bottom-tray #grid')
                    }
                }

                this.loading = false
            }
        },
        setIsTrayShown(show) {
            if (show) {
                document.body.style.setProperty('padding-right', `${window.innerWidth - document.documentElement.clientWidth}px`) // Prevent page from shifting when the tray is opened
                document.documentElement.classList.add('tray-open')

                // Removing this but leaving commented out - not sure why this was added but it shoots the filtering tray off the screen on mobile?
                // if (is_mobile_device && this.$store.general.tray.openTray === 'results-filters') {
                //     this.trayContents.style.setProperty('transform', 'translateX(-100%)')
                // }

                const trayBody = this.tray.querySelector('.tray-body');
                trayBody.scrollTop = 0; // Scroll to top of tray content

                this.setTrayHeight(this.$store.general.tray.height);
                this.setTrayContent();

                // Check if need to scroll to a section. Use the class name
                if (this.$store.general.tray.additionalData.scrollToSection) {
                    const className = this.$store.general.tray.additionalData.sectionName;
                    const targetSection = this.tray.querySelector('.' + className);

                    if (targetSection) {
                        const targetOffset = targetSection.offsetTop - trayBody.offsetTop;
                        trayBody.scrollTop = targetOffset; // Scroll to the target section
                    }
                }
            } else {
                document.body.style.setProperty('padding-right', '0')
                document.documentElement.classList.remove('tray-open')
                this.trayContents.style.setProperty('transform', 'translateX(0%)')
                this.setTrayHeight(0)
                this.setTrayContent(true)
            }
        },
        setTrayHeight(height) {
            const shouldOverrideHeight = this.shouldOverrideHeight();
            const trayHeightUnit = this.$store.general.tray.heightUnit;

            // Set tray height based on unit, ensuring 'vh' is within 0-100 range
            this.trayHeight = trayHeightUnit === 'vh' ? Math.max(0, Math.min(100, height)) : height;
            this.trayContents.style.height = shouldOverrideHeight ? 'auto' : `${this.trayHeight}${trayHeightUnit}`;

            // Add or remove "fullscreen" class based on tray height and unit
            const isFullscreen = (trayHeightUnit === 'vh' && this.trayHeight === 100) ||
                (trayHeightUnit === 'px' && this.trayHeight === window.innerHeight);

            if (isFullscreen) {
                this.trayContents.classList.add("fullscreen");
            } else {
                this.trayContents.classList.remove("fullscreen");
            }
        },
        onDragStart(event) {
            this.dragPosition = touchPosition(event).pageY
            this.trayContents.classList.add("not-selectable")
            this.draggableArea.style.cursor = document.body.style.cursor = "grabbing"
        },
        onDragMove(event) {
            if (this.dragPosition === undefined) return

            const y = touchPosition(event).pageY
            const deltaY = this.dragPosition - y
            const multiplier = this.$store.general.tray.heightUnit === 'vh' ? 100 : 500;
            const deltaHeight = deltaY / window.innerHeight * multiplier;

            this.setTrayHeight(this.trayHeight + deltaHeight);
            this.dragPosition = y
        },
        onDragEnd() {
            this.dragPosition = undefined
            this.trayContents.classList.remove("not-selectable")
            this.draggableArea.style.cursor = document.body.style.cursor = ""

            const jsTrayInnerFrame = document.querySelector('#js-tray-inner-frame');
            const trayHeightUnit = this.$store.general.tray.heightUnit
            let trayStartHeight = this.$store.general.tray.height

            // Determine tray height adjustments based on unit (vh or px) and current height
            const isVhUnit = trayHeightUnit === 'vh';
            const decreaseThreshold = isVhUnit ? 10 : (this.$store.general.tray.openTray === 'signup-form-tray' ? 0.50 : 0.30) * jsTrayInnerFrame.clientHeight;
            const increaseThreshold = isVhUnit ? 90 : 0.9 * window.innerHeight;
            const maxHeight = isVhUnit ? 100 : window.innerHeight;

            // Increase tray height if alert comes in
            if (jsTrayInnerFrame.querySelector('.alert') && !this.trayHeightUpdated) {
                this.setTrayHeight(this.$store.general.tray.height);
                this.trayHeightUpdated = true;
            }

            // Apply visibility and height adjustments based on thresholds
            if (this.trayHeight < (trayStartHeight - decreaseThreshold)) {
                this.setIsTrayShown(false);
                this.$store.general.updateOpenTray('NONE');
                clearAllBodyScrollLocks()
            } else if (this.trayHeight > increaseThreshold) {
                this.setTrayHeight(maxHeight);
            } else {
                this.setTrayHeight(trayStartHeight);
            }
        },
        relocateElementBySelector(elementSelector, destSelector) {
            let element = document.querySelector(elementSelector);
            let destElement = document.querySelector(destSelector);
            let elementParent = element.parentElement;
            elementParent.removeChild(element);
            destElement.appendChild(element);
        },
        backToPreviousTray() {
            this.$store.general.tray = JSON.parse(JSON.stringify(this.$store.general.previousTray));
            this.$store.general.previousTray = {}
        },

        shouldOverrideHeight() {
            let isProfileMenu = this.tray.querySelector('.container-xl.profile-menu');
            let isNavbarMenu = this.tray.querySelector('.container-xl.navbar-menu');

            return isProfileMenu || isNavbarMenu;
        },
        reviewTranslation() {
            if(document.querySelector("#translation-button")) {
                document.querySelector("#translation-button").addEventListener('click', function () {
                    const reviewId = this.getAttribute("data");
                    const englishReview = document.getElementById(`translated-review-${reviewId}`);
                    const originalReview = document.getElementById(`original-review-${reviewId}`);
                    const translationText = document.getElementById(`review-translation-${reviewId}`);

                    if (englishReview && originalReview) {
                        if (englishReview.classList.contains("d-none")) {
                            englishReview.classList.remove("d-none");
                            originalReview.classList.add("d-none");
                            this.innerHTML = '<u>Show original</u>';
                            translationText.textContent = 'This review has been automatically translated using Google.';
                        } else {
                            englishReview.classList.add("d-none");
                            originalReview.classList.remove("d-none");
                            this.innerHTML = '<u>Translate to English</u>';
                            translationText.textContent = 'This review is displayed in the original language.';
                        }
                    }
                });
            }
        },
        responseTranslation() {
            if(document.querySelector("#host-response-translation-button")) {
                document.querySelector("#host-response-translation-button").addEventListener('click', function () {
                    const reviewId = this.getAttribute("data");
                    const englishResponse= document.getElementById(`translated-host-response-${reviewId}`);
                    const originalResponse = document.getElementById(`original-host-response-${reviewId}`);
                    const translationText = document.getElementById(`host-response-translation-${reviewId}`);

                    if (englishResponse && originalResponse) {
                        if (englishResponse.classList.contains("d-none")) {
                            englishResponse.classList.remove("d-none");
                            originalResponse.classList.add("d-none");
                            this.innerHTML = '<u>Show original</u>';
                            translationText.textContent = 'This review has been automatically translated using Google.';
                        } else {
                            englishResponse.classList.add("d-none");
                            originalResponse.classList.remove("d-none");
                            this.innerHTML = '<u>Translate to English</u>';
                            translationText.textContent = 'This review is displayed in the original language.';
                        }
                    }
                });
            }
        },
    };
};

//set higher z-index for LS
if (site === 'ls' && is_mobile_device) {
    const jsBottomTray = document.getElementById('js-bottom-tray');
    jsBottomTray.style.zIndex = 1051;
}

const touchPosition = (event) =>
    event.touches ? event.touches[0] : event

const loadingTrayHtml = `<div id="loader-container" class="w-100 d-flex align-items-center justify-content-center">
                            <div class="btn-loader">
                                <i class="far fa-spinner-third fa-spin fa-2xl" style="font-size:40px;"></i>
                            </div>
                        </div>`;
